import React, { useState, useContext, useEffect } from "react";
import {
  Typography,
  Stack,
  TextField,
  Button,
  InputAdornment,
  Avatar,
} from "@mui/material";
import { useFormik, Form, FormikProvider } from "formik";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import * as Yup from "yup";
import { useQuery, useMutation } from "@apollo/client";
import { useNavigate } from "react-router-dom";
//Srcs
import "./login.scss";
import { AuthContext } from "../Context/AuthContext";
import loginImage from "../Assets/logo.svg";
import CircularProgress from "@mui/material/CircularProgress";
import { GET_USER_LOGIN } from "../Schema/User";
import { USER_LOGIN } from "../Schema/User";

export default function Login() {
  const navigate = useNavigate();

  const { setAlert, dispatch } = useContext(AuthContext);
  const [iconReload, setIconReload] = useState(false);

  // =================== get user login ==================
  const { data } = useQuery(GET_USER_LOGIN, {
    onCompleted: ({ getUserLogin }) => {
      if (getUserLogin?.status) {
        window.localStorage.setItem(
          "userLogin",
          JSON.stringify(getUserLogin.user)
        );
      }
    },
    fetchPolicy: "network-only",
  });

  // hide password hook
  const [show, setShow] = useState(false);
  const handleClick = () => setShow(!show);

  const [userLogin] = useMutation(USER_LOGIN, {
    onCompleted: ({ userLogin }) => {
      // console.log("userLogin::", userLogin)
      if (userLogin?.status === true) {
        setAlert(true, "success", userLogin?.message);
        window.localStorage.setItem("token", JSON.stringify(userLogin?.token));
        // navigate("/dashboard");
        navigate("/party-members");
        setTimeout(() => {
          setIconReload(false);
        }, 1600);

        dispatch({
          type: "LOGGED_IN_USER",
          payload: {
            email: userLogin?.user?.email
              ? userLogin?.user?.email
              : "customtoken@user.com",
            token: userLogin?.token,
          },
        });
      } else {
        setAlert(true, "error", userLogin?.message);
        setIconReload(false);
      }
    },
    onError: (err) => {
      setAlert(true, "error", err?.message);
    },
  });

  const LoginSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email!").required("Required"),
    password: Yup.string()
      .required("Required")
      .min(8, "Password must be 8 characters!"),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },

    validationSchema: LoginSchema,
    onSubmit: async (values) => {
      // console.log("values::", values);
      setIconReload(true);
      userLogin({
        variables: {
          ...values,
        },
      });
    },
  });

  const { errors, touched, handleSubmit, getFieldProps } = formik;

  useEffect(() => {
    if (data?.getUserLogin?.status && iconReload === true) {
      setAlert(true, "success", "Login success!");
      window.location.reload("/party-members");
    }

    if (data?.getUserLogin?.status === false && iconReload === true) {
      setAlert(true, "error", "Login not success!");
      window.localStorage.removeItem("token");
      window.location.reload();
    }
  }, [iconReload, data?.getUserLogin?.status]);

  return (
    <Stack
      direction="column"
      justifyContent="center"
      className="login-container"
    >
      <Stack direction="row" justifyContent="center" sx={{ width: "100%" }}>
        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <Stack direction="column" className="box-container" spacing={2}>
              <Stack direction="column" spacing={1.5}>
                <Stack direction="row" justifyContent="center">
                  <Avatar
                    sx={{ width: 100, height: 100 }}
                    variant="square"
                    alt="logo"
                    src={loginImage}
                  />
                </Stack>
                <Typography
                  variant="body2"
                  align="center"
                  className="login-subtitle"
                >
                  ប្រព័ន្ធគ្រប់គ្រងសមាជិកបក្ស
                </Typography>
              </Stack>

              <Stack
                direction="column"
                justifyContent="center"
                width="100%"
                className="box-login"
                spacing={2}
              >
                <Stack direction="column">
                  <Typography className="label-login">អ៊ីមែល</Typography>
                  <TextField
                    fullWidth
                    size="small"
                    className="input-login"
                    placeholder="example@company.com"
                    {...getFieldProps("email")}
                    error={Boolean(touched.email && errors.email)}
                    helperText={touched.email && errors.email}
                  />
                </Stack>
                <Stack direction="column" spacing={0.5}>
                  <Typography className="label-login">ពាក្យសម្ងាត់</Typography>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="ពាក្យសម្ងាត់"
                    type={show ? "text" : "password"}
                    {...getFieldProps("password")}
                    error={Boolean(touched.password && errors.password)}
                    helperText={touched.password && errors.password}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start" onClick={handleClick}>
                          {show ? (
                            <VisibilityIcon className="viewpw-icon" />
                          ) : (
                            <VisibilityOffIcon className="viewpw-icon" />
                          )}
                        </InputAdornment>
                      ),
                    }}
                  />
                  {/* <Stack direction="row-reverse">
                    <Link to={"/forgot-password"} className="forgot-password">
                      ភ្លេច​លេខសំងាត់?
                    </Link>
                  </Stack> */}
                </Stack>
              </Stack>
              <Stack direction="column">
                <Button
                  className="btn-sign-in"
                  type="submit"
                  endIcon={
                    iconReload ? (
                      <CircularProgress sx={{ color: "#fff" }} size="20px" />
                    ) : null
                  }
                >
                  ចូល
                </Button>
              </Stack>
              <Typography className="footer-copy-right">
                Copyright © 2023 Go Global IT. All rights reserved.
              </Typography>
            </Stack>
          </Form>
        </FormikProvider>
      </Stack>
    </Stack>
  );
}
